import React from 'react'
import {BrowserRouter,Routes,Route} from "react-router-dom"
import Navbar from './components/Navbar'
import Home from './components/Home'
import Blog from './components/Blog'
import Projects from './components/Projects'
import Contact from './components/Contact'
import Footer from './components/Footer'
function App() {
  document.title = 'Sahil Jena - Full Stack Developer'
  return (
    <BrowserRouter>
      <Navbar />
      <main className='flex flex-col justify-center bg-white dark:bg-black px-8 text-gray-900 dark:text-gray-100'>
          <div className='flex font-bvp flex-col justify-center items-start max-w-2xl mx-auto mb-16'>
              <Routes>
                <Route path='/' exact element={<Home/>} />
                <Route path='/blog' exact element={<Blog/>} />
                <Route path='/projects' exact element={<Projects />} />
                <Route path='/contact' exact element={<Contact />} />
              </Routes>
          </div>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
export default App;